<template>
  <div :isNonStickyVariantProp="isNewHomeBtnVariant">
    <div
      class="col-sm-12 location-message-banner pd12 flex-row mb16"
      id="location-message-banner-id"
      v-if="!(isLocationPermissionGiven() || isTrueLocationDetected)"
    >
      <span class="location-icon mr8 flex-column">
        <i class="jfi-location fs-17"></i>
      </span>
      <span class="location-nudge-message lh16"
        >Give us your exact location for seamless delivery</span
      >
      <button @click="detectGeoLocationPopup" class="line-btn sm">
        Use current location
      </button>
    </div>
  </div>
</template>

<script>
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";

export default {
  name: "LocationMessageBanner",

  components: {},

  data() {
    return {
      cachedComponentOffsetTop: 0,
      removeSticky:false
    };
  },

  mounted() {
      window.addEventListener("scroll", () => {
        this.watchSticky();
      });
  },

  destroyed() {
      window.removeEventListener("scroll", this.watchSticky);
  },

  computed: {
    isTrueLocationDetected() {
      return this.$store.state.Location.isTrueLocationDetected;
    },
    isNewHomeBtnVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL
      ) {
        this.removeSticky=true;
        return true;
      } else {
        this.removeSticky=false;
        return false;
      }
    },
  },

  methods: {
    isLocationPermissionGiven() {
      return LocalStorageFunc.getIsLocationPermisssionGiven();
    },
    watchSticky() {
      if(this.removeSticky){
        return;
      }

      let componentRef = document.getElementById("location-message-banner-id");
      if (!componentRef) return;
      if (!this.cachedComponentOffsetTop && componentRef.offsetTop > 0) {
        this.cachedComponentOffsetTop = componentRef.offsetTop;
      }
      if (window.pageYOffset >= this.cachedComponentOffsetTop) {
        componentRef.classList.add("watch-sticky");
      } else {
        componentRef.classList.remove("watch-sticky");
      }
    },
    detectGeoLocationPopup() {
      this.$store.dispatch(keyMapsAction.DETECT_GEO_LOCATION_POPUP, {
        source: "locationPopupBanner",
        showModalM: () => this.showModalM(),
      });
    },
    showModalM() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL,
        true
      );
    },
  },
};
</script>

<style scoped></style>
